<div class="page-container container toolbox-container">
  <app-utility-toolbar />
  <h1 class="header col-12 mb-0">Toolbox</h1>

  <app-download-profile
    [applications]="applications"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-download-log-files (toggleLoading)="toggleLoading()" />

  <mat-divider />
  <app-download-unit-profiles
    [applications]="applications"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-download-group-profile
    [applications]="applications"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-patch-profile
    [applications]="applications"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-download-db-spreadsheet
    [lifeProductTables]="lifeProductTables"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-import-products
    [lifeProductTables]="lifeProductTables"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-delete-products
    [lifeProductTables]="lifeProductTables"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-download-handlebar-template (toggleLoading)="toggleLoading()" />

  <mat-divider />
  <app-upload-handlebar-template (toggleLoading)="toggleLoading()" />

  <mat-divider />
  <app-upload-report-template
    [reportTemplates]="reportTemplates"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-req-report-template
    [reportTemplates]="reportTemplates"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-custom-report-req
    [applications]="applications"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-data-dictionary
    [applications]="applications"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-group-schema
    [applications]="applications"
    (toggleLoading)="toggleLoading()"
  />

  <mat-divider />
  <app-download-mapping-files (toggleLoading)="toggleLoading()" />

  <ngx-loading [show]="loading" />
</div>
